import { faInfoCircle, faPartyHorn } from '@fortawesome/pro-regular-svg-icons';
import { faCircleExclamation, faWarning } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import VoxelDialog, { VoxelDialogProps } from './VoxelDialog';

export interface VoxelAlertDialogProps extends VoxelDialogProps {
  severity?: VoxelAlertDialogSeverity;
}

export type VoxelAlertDialogSeverity = 'error' | 'warning' | 'info' | 'success';

const VoxelAlertDialog: React.FC<VoxelAlertDialogProps> = ({
  severity,
  titleIcon,
  ...dialogProps
}) => {
  let textColor = '';

  if (severity === 'error') {
    textColor = 'text-error-600/90';
    titleIcon = (
      <FontAwesomeIcon icon={faCircleExclamation} size={'2xl'} className={`${textColor}`} />
    );
  }
  if (severity === 'warning') {
    textColor = 'text-warning-600';
    titleIcon = <FontAwesomeIcon icon={faWarning} size={'2xl'} className={`${textColor}`} />;
  }
  if (severity === 'info') {
    textColor = 'text-info-700/80';
    titleIcon = <FontAwesomeIcon icon={faInfoCircle} size={'2xl'} className={`${textColor}`} />;
  }
  if (severity === 'success') {
    textColor = 'text-success-600/70';
    titleIcon = <FontAwesomeIcon icon={faPartyHorn} size={'2xl'} className={`${textColor}`} />;
  }

  return <VoxelDialog {...dialogProps} titleIcon={titleIcon} />;
};

export default VoxelAlertDialog;
